// Etiquetas de presentación: convierten el código guardado (ej. "neumaticos") en un nombre lindo
// ("Neumáticos") SOLO para mostrar. No cambian el valor almacenado en la base.

const CATEGORY_LABELS: Record<string, string> = {
  neumaticos: 'Neumáticos',
  lubricantes: 'Lubricantes',
  aceites: 'Aceites',
  repuestos: 'Repuestos',
  accesorios: 'Accesorios',
  baterias: 'Baterías',
  filtros: 'Filtros',
  otros: 'Otros',
  servicio: 'Servicio',
  servicios: 'Servicios',
};

export const prettyCategory = (code?: string | null): string => {
  if (!code) return '';
  const key = String(code).toLowerCase().trim();
  if (CATEGORY_LABELS[key]) return CATEGORY_LABELS[key];
  return String(code).charAt(0).toUpperCase() + String(code).slice(1);
};
